var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"align":"right","text":"","color":"red"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',[_vm._v("mdi-trash-can-outline")]),_vm._v(" Удалить")],1)}
var staticRenderFns = []

export { render, staticRenderFns }